__turbopack_context__.v({
  "default": "Toaster-module-scss-module__BZGbea__default",
  "description": "Toaster-module-scss-module__BZGbea__description",
  "error": "Toaster-module-scss-module__BZGbea__error",
  "progress": "Toaster-module-scss-module__BZGbea__progress",
  "root": "Toaster-module-scss-module__BZGbea__root",
  "slideIn": "Toaster-module-scss-module__BZGbea__slideIn",
  "success": "Toaster-module-scss-module__BZGbea__success",
  "title": "Toaster-module-scss-module__BZGbea__title",
  "viewport": "Toaster-module-scss-module__BZGbea__viewport",
});
